
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pvc/sliding-doors/gealan",
      function () {
        return require("private-next-pages/pvc/sliding-doors/gealan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pvc/sliding-doors/gealan"])
      });
    }
  